export default {
  layout: {
        zh: '简体中文',
        tc: '繁體中文',
        en: 'English',
        kr: '한국어',
        jp: '日本語',
  },
  footer: {},
  menu: {
      home: '首頁',
      mining: '礦機',
      wallet: '錢包',
      me: '我的',
      login: '登錄'
  },
  home: {
      buy: '購買',
      dailyEarnings: '當日收益',
      topUp: '去充值',
      desc: '產品參數描述為隱性增長而生，為巨大成功而設計',
      popup: {
          buy: '立即購買',
          desc: '礦機收益，每天1%的收益(即每日3U)需每30天支付數據盒(35U)才能獲得，已包含一個數據盒',
          totalAmount: '總金額',
          wallet: '資金錢包',
          revenue: '收益錢包',
          pls: '使用收益錢包支付',
          config: '配置錢包',
          most: '最多使用',
          confirmPurchase: '確認購買',
          plsDes: '請輸入推薦人',
          confirm: '確認',
      }
  },
  mining: {
      title: '我的礦機列表',
      day: '當日總產出',
      activate: '持有待激活數據盒(個)',
      miningrig: '持有礦機(台)',
      output: '正在產出',
      dataCapsule: '數據盒',
      time: '購買時間',
      remaining: '剩餘天數(天)',
      today: '今日產出',
      total: '總產出',
      expired: '即將過期',
      stop: '停產',
  },
  record: {
      title: '賬戶記錄',
      empty: '暫無記錄',
      wallet: '資金錢包',
      time: '日期',
      remark: '備註:見點釋放',
      complimentary: '備註:贈送',
      static: '備註:靜態收益',
  },
  wallet: {
      title: '我的錢包',
      record: '資金記錄',
      static: '當日靜態收益',
      dynamic: '當日動態獎勵',
      topup: '充值',
      withdraw: '提現',
      totalRevenue: '礦機總收益',
      totalReward: '總獎勵',
      funds: '資金錢包',
              fund1: '資金錢包',
        fund2: '效益錢包',
        fund3: '配置錢包',
  },
  withdraw: {
      title: '提現',
      revenue: '收益錢包',
      amount: '提現金額',
      confirm: '確認提現',
      rule: '提現規則',
      desc: '提現為每筆5U或5%,按價高計算',
      desc1: '最低提現額度為10U',
      list: '提現列表',
      success: '成功',
      time: '日期',
      error: '失敗',
  },
  me: {
      recommend: '我的推薦人',
      subscription: '認購業績',
      directReferral: '直推業績',
      team: '我的團隊(人)',
      performance: '團隊業績',
      serialNumber: '編號',
      level: '等級',
      individual: '個人業績',
      time: '註冊日期',
      home: '首頁',
      last: '最後',
  },
};